module.exports = __webpack_public_path__ + "media/hero_mv_sp.902e5ebb.ogg";